import { LOADER_PHASES } from '../utils';
import {
  CogIcon,
  Icon,
  IconComponent,
  ListIcon,
  Pane,
  Paragraph,
  PlayIcon,
  Tab,
  Tablist,
  UserIcon,
} from 'evergreen-ui';
import { FC, useState } from 'react';
import styled from 'styled-components';

const icon = {
  play: PlayIcon,
  user: UserIcon,
  cog: CogIcon,
  list: ListIcon,
};
const tabs = ['play', 'user', 'cog', 'list'];

const StyledTab = styled(Tab)`
  position: relative;
  border: none !important;
  z-index: 1;

  &:hover,
  &:active,
  &[aria-selected='true'] {
    background-color: #1f2021 !important;
  }

  &:focus {
    box-shadow: none;
  }

  &::before {
    content: '';
    position: absolute;
    background: radial-gradient(
      50% 50% at 50% 50%,
      #1d88c5 0%,
      rgba(29, 136, 197, 0.63) 26.04%,
      rgba(29, 136, 197, 0.4) 40.52%,
      rgba(29, 136, 197, 0.1) 80%,
      rgba(29, 136, 197, 0) 100%
    );
    left: 0;
    right: 0;
    top: -16px;
    height: 40px;
    box-shadow: inset 0 -20px #1f2021;
    z-index: -1;
    opacity: 0;
    transition: opacity ease 0.2s;
  }
  &[aria-selected='true']::before {
    opacity: 0.5;
  }

  &::after {
    content: '';
    position: absolute;
    background: linear-gradient(90deg, rgba(200, 226, 240, 0) 0%, rgb(200, 226, 240) 50%, rgba(200, 226, 240, 0) 100%);
    left: 0;
    right: 0;
    top: 4px;
    height: 2px;
    z-index: -1;
    opacity: 0;
    transition: opacity ease 0.2s;
  }
  &[aria-selected='true']::after {
    opacity: 1;
  }

  &:hover > div {
    color: #ffffff88;
  }
  &[aria-selected='true'] > div {
    color: #fff;
  }

  &:hover > div,
  &[aria-selected='true'] > div {
    &::before {
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: #329cd960;
      box-shadow: 0 0 20px #329cd9, 0 0 20px #329cd9;
      z-index: 0;
      left: calc(50% - 8px);
      top: calc(50% - 8px);
    }
    & > svg {
      z-index: 1;
    }
  }
`;

const NavTabs = ({ contents, selectedTab, setSelectedTab }) => {
  return (
    <Pane height="100%" background="#1F2021" display="flex" flexDirection="column">
      <Pane flex="1" paddingBottom={0}>
        {tabs.map((tab, index) => (
          <Pane
            key={tab}
            id={`panel-${tab}`}
            role="tabpanel"
            aria-labelledby={tab}
            aria-hidden={index !== selectedTab}
            display={index === selectedTab ? 'block' : 'none'}
            height="100%"
          >
            {contents[tab]}
          </Pane>
        ))}
      </Pane>
      <Pane display="flex" height="72px" minHeight="72px" maxHeight="72px"></Pane>
      <Tablist height="72px" display="flex" justifyContent="center" position="fixed" bottom="0" left="0" right="0">
        <Pane maxWidth={540} width="100%" display="flex" background="#1F2021" height="72px">
          {tabs.map((tab, index) => {
            return (
              <StyledTab
                key={tab}
                id={tab}
                onSelect={() => setSelectedTab(index)}
                isSelected={index === selectedTab}
                aria-controls={`panel-${tab}`}
                flex="1"
                height="100%"
                marginRight="0!important"
              >
                <Icon icon={icon[tab]} size={24} />
              </StyledTab>
            );
          })}
        </Pane>
      </Tablist>
    </Pane>
  );
};

export default NavTabs;
